import { Component, ChangeDetectorRef, NgZone, AfterViewChecked, DestroyRef, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map, startWith } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SessionService } from '@app/shared/services/session.service';
import { ToasterService } from '@app/shared/components/toaster/toaster.service';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements AfterViewChecked {
  private destroyRef = inject(DestroyRef);
  private prevPath = '';

	constructor(
		public session: SessionService,
    private changeDetector: ChangeDetectorRef,
    private zone: NgZone,
    private router: Router,
    private toaster: ToasterService
	) {

    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map(e => e.urlAfterRedirects.split('?')[0]),
      startWith(this.router.url.split('?')[0]),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(path => {
      const isLogin = path === '/' || path.startsWith('/login');
      const wasLogin = this.prevPath === '/' || this.prevPath.startsWith('/login');

      // clear toaster only when entering login from a non-login page!
      if (isLogin && !wasLogin) {
        this.toaster.clear();
      }

      this.prevPath = path;
    });
  }

  ngAfterViewChecked() {
    // prevent spinner "Expression change errors"
    this.zone.run(() => {
      this.changeDetector.detectChanges();
    });
  }

}
